import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPembelianService = new CrudCustom('/pembelian');
export default TransaksiPembelianService;
